module.exports = __webpack_public_path__ + "static/media/cover9.da71cb5b.jpeg";